// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"d6dd36bc","452":"2f6debc0","793":"6a23a533"}[chunkId] + ".css";
};